<template>
  <div class="chooseletter">
    <div class="title">
        请选择对方与您进行骚扰的内容
    </div>
    <div v-show="selectLetter.length > 0" class="showletterwrap">
      <div class="showletter">
        <LetterItem
        v-for="(item,index) in selectLetter"
        :key="index"
        :item="item">
        </LetterItem>
      </div>
      <z-button @click="changeLetter" type="link">修改私信</z-button>
    </div>
    <z-button class="uploadbtn" icon="plus" v-show="selectLetter.length == 0" @click="changeLetter">选择私信内容</z-button>
    <LetterList @select="LetterSelect" :show="showLetter" @close="closeLetter"></LetterList>
  </div>
</template>

<script>
import LetterList from '../LetterList'
import LetterItem from '../LetterList/LetterItem'
import { Button } from '@zz-common/zz-ui'
export default {
  name: 'ChooseLetter',
  components: {
    LetterList,
    LetterItem,
    zButton: Button
  },
  data() {
    return {
      submitData: {},
      selectLetter: [],
      showLetter: false
    }
  },
  props: {
    Finished: {
      type: Function,
      default: () => {}
    } //向外传递数据
  },
  methods: {
    changeLetter() {
      this.showLetter = true
    },
    LetterSelect(data) {
      this.selectLetter = data
      this.Finished(data)
    },
    closeLetter() {
      this.showLetter = false
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>